<template>
  <section class="page_box">
    <img :src="imgUrl" alt="" />
    <div id="bigBox" class="bannerTitleBox" v-if="textFlag">
      <div class="bannerTitle">
        <h1>润信数字智能科技</h1>
        <p>AI赋能千行百业</p>
        <button>立即查看</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
    },
    // 写法2：带默认值
    textFlag: {
      type: Boolean,
      default: false,
    },
    // 写法1：简单类型 + 必填（最常用）
  },
  name: "BannerText",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.page_box {
  width: 100%;
  height: 703px;
  overflow: hidden;
}
.page_box > img {
  width: 100%;
}
</style>
